/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FragmentNames {
  ACCREDITATION_AMOUNT_PROFESSIONALS = 'accreditation-amount-professionals',
  ACCREDITATION_BANK_DATA = 'accreditation-bank-data',
  ACCREDITATION_BEDS = 'accreditation-beds',
  ACCREDITATION_BEDS_AND_EQUIPMENTS = 'accreditation-beds-and-equipments',
  ACCREDITATION_CLINICAL_STAFF = 'accreditation-clinical-staff',
  ACCREDITATION_CNES = 'accreditation-cnes',
  ACCREDITATION_COMPLEMENTARY_DATA = 'accreditation-complementary-data',
  ACCREDITATION_CONCLUSION = 'accreditation-conclusion',
  ACCREDITATION_DOCUMENTS = 'accreditation-documents',
  ACCREDITATION_EMPLOYEES = 'accreditation-employees',
  ACCREDITATION_EQUIPMENTS = 'accreditation-equipments',
  ACCREDITATION_ESTABLISHMENT = 'accreditation-establishment',
  ACCREDITATION_MEDICINE_MATERIALS = 'accreditation-medicine-materials',
  ACCREDITATION_OUTSOURCED_SERVICES = 'accreditation-outsourced-services',
  ACCREDITATION_PACKAGE_DETAILS = 'accreditation-package-details',
  ACCREDITATION_PACKAGES = 'accreditation-packages',
  ACCREDITATION_PROCEDURES = 'accreditation-procedures',
  ACCREDITATION_PROFESSIONALS = 'accreditation-professionals',
  ACCREDITATION_QUALIFICATIONS = 'accreditation-qualifications',
  ACCREDITATION_SERVICE_MATERIALS = 'accreditation-service-materials',
  ACCREDITATION_SERVICES = 'accreditation-services',
  ACCREDITATION_SIDEBAR_MENU = 'accreditation-sidebar-menu',
  ACCREDITATION_SPECIALTY = 'accreditation-specialty',
  ACCREDITATION_UPDATE = 'accreditation-update',
  ACTION_PLAN = 'action-plan',
  ACTION_PLAN_DETAILS = 'action-plan-details',
  ACTION_PLAN_NEW = 'action-plan-new',
  ASSING_TERM = 'assing-term',
  CALL_CATEGORIES = 'call-categories',
  CALL_DETAILS = 'call-details',
  CALLS = 'calls',
  CHANGE_PW = 'change-pw',
  CNES_DETAIL = 'cnes-detail',
  CNES_SEARCH = 'cnes-search',
  CONTRACT_ATTACHMENTS = 'contract-attachments',
  CONTRACT_DETAILS = 'contract-details',
  CONTRACTS = 'contracts',
  COOKIE_POLICIES = 'cookie-policies',
  DASHBOARD = 'dashboard',
  DOCUMENTS = 'documents',
  DOCUMENTS_DETAILS = 'documents-details',
  FORM_REGISTER = 'form-register',
  FORM_TECHNICAL_VISIT = 'form-technical-visit',
  HPMS_REPORTS_MODAL = 'hpms-reports-modal',
  INACTIVITY = 'inactivity',
  INDICATOR_DETAILS = 'indicator-details',
  INDICATOR_HISTORIES = 'indicator-histories',
  INDICATORS = 'indicators',
  LOCATOR_BANK_DATA = 'locator-bank-data',
  LOCATOR_MEDICINE_MATERIALS = 'locator-medicine-materials',
  LOCATOR_MEDICINE_MATERIALS_PACKAGE = 'locator-medicine-materials-package',
  LOCATOR_PROCEDURE_PACKAGE = 'locator-procedure-package',
  LOCATOR_SERVICE = 'locator-service',
  LOCATOR_TABLE_PROCEDURE = 'locator-table-procedure',
  LOGIN = 'login',
  MEETING_MINUTE_CONSULTATION = 'meeting-minute-consultation',
  MEETING_MINUTE_DETAILS = 'meeting-minute-details',
  MESSAGE_DETAILS = 'message-details',
  MESSAGES = 'messages',
  MESSAGES_SUMMARY = 'messages-summary',
  MY_DATA = 'my-data',
  NEGOTIATION = 'negotiation',
  NEGOTIATION_ATTACHMENTS = 'negotiation-attachments',
  NEGOTIATION_CONTRACT_ATTACHMENTS = 'negotiation-contract-attachments',
  NEGOTIATION_CONTRACTUAL_AMENDMENT = 'negotiation-contractual-amendment',
  NEGOTIATION_CONTRACTUAL_DRAFT = 'negotiation-contractual-draft',
  NEGOTIATION_DETAILS = 'negotiation-details',
  NEGOTIATION_DETAILS_TABCONTROL = 'negotiation-details-tabcontrol',
  NEGOTIATION_HISTORY = 'negotiation-history',
  NEGOTIATION_MATERIALS = 'negotiation-materials',
  NEGOTIATION_PACKAGES = 'negotiation-packages',
  NEGOTIATION_PROCEDURES = 'negotiation-procedures',
  NEGOTIATION_PROPOSAL = 'negotiation-proposal',
  NEGOTIATION_SERVICES = 'negotiation-services',
  NEGOTIATION_VALUE_SIDEBAR_MENU = 'negotiation-value-sidebar-menu',
  NEW_ACCREDITATION_UPDATE = 'new-accreditation-update',
  NEW_CALL = 'new-call',
  NEW_PW = 'new-pw',
  NEW_USER_STEPS = 'new-user-steps',
  OIDC = 'oidc',
  PDF_VIEWER = 'pdf-viewer',
  PRIVACY = 'privacy',
  PROVIDER = 'provider',
  PROVIDER_LOCATOR = 'provider-locator',
  REDIRECT = 'redirect',
  REPORTS = 'reports',
  RESET_PW = 'reset-pw',
  ROOT = 'root',
  ROUTES = 'routes',
  SEND_DOCUMENTS = 'send-documents',
  SOCIAL_NETWORK = 'social-network',
  SSO_CALLBACK = 'sso-callback',
  SSO_ERROR = 'sso-error',
  TASK_DETAILS = 'task-details',
  TASKS = 'tasks',
  TECHNICAL_VISIT = 'technical-visit',
  TECHNICAL_VISIT_APPOINTMENTS = 'technical-visit-appointments',
  TECHNICAL_VISIT_DETAIL = 'technical-visit-detail',
  TECHNICAL_VISIT_FORMS = 'technical-visit-forms',
  TECHNICAL_VISIT_INCONSISTENCIES = 'technical-visit-inconsistencies',
  USER_CONFIRM = 'user-confirm',
  USER_CONFIRM_FAIL = 'user-confirm-fail',
}
export { FragmentNames };
